import React from "react";
import { ProgressBar } from "react-bootstrap";

const RandomizationbyArm = ({ armData, kitData }) => {
  // Default data if no props provided
  const defaultArmData = [
    { name: "Arm A — RZX-19 200mg", value: 2 },
    { name: "Arm B — RZX-19 400mg", value: 2 },
    { name: "Arm C — Placebo", value: 2 },
  ];

  const defaultKitData = {
    dispensed: 0,
    quarantined: 0,
    totalPool: 78
  };

  const data = armData || defaultArmData;
  const kits = kitData || defaultKitData;
  
  // Calculate total for progress bars
  const total = data.reduce((sum, arm) => sum + arm.value, 0);
  const maxValue = Math.max(...data.map(arm => arm.value), 10);

  return (
    <div className="randomization-by-arm">
      {/* Blinded Notice */}
      <div className="alert alert-info py-1 px-2 mb-3" style={{ fontSize: "12px", backgroundColor: "#e8f4f8", border: "none" }}>
        <span className="text-info">ℹ️</span> Study is blinded. Arm labels shown for operational planning only.
      </div>

      {/* Arm List with Progress Bars */}
      <div className="arm-list">
        {data.map((arm, index) => {
          const percentage = (arm.value / maxValue) * 100;
          return (
            <div key={index} className="mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <span style={{ fontSize: "13px" }}>
                  {arm.name}
                </span>
                <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {arm.value}
                </span>
              </div>
              <ProgressBar 
                variant="primary" 
                now={Math.min(percentage, 100)} 
                style={{ 
                  height: "6px", 
                  borderRadius: "3px",
                  backgroundColor: "#e9ecef"
                }}
              />
            </div>
          );
        })}
      </div>

      {/* Divider */}
      <hr className="my-2" />

      {/* Kit Statistics */}
      <div className="kit-stats">
        <div className="d-flex justify-content-between align-items-center py-1">
          <span style={{ fontSize: "13px" }}>Kits dispensed</span>
          <span style={{ fontSize: "14px", fontWeight: "bold" }}>
            {kits.dispensed}
          </span>
        </div>
        <div className="d-flex justify-content-between align-items-center py-1">
          <span style={{ fontSize: "13px" }}>Quarantined</span>
          <span style={{ fontSize: "14px", fontWeight: "bold" }}>
            {kits.quarantined}
          </span>
        </div>
        <div className="d-flex justify-content-between align-items-center py-1 border-top pt-2 mt-1">
          <span style={{ fontSize: "13px", fontWeight: "bold" }}>Total kit pool</span>
          <span style={{ fontSize: "16px", fontWeight: "bold", color: "#103C5E" }}>
            {kits.totalPool}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RandomizationbyArm;